import { render } from "./communications.vue?vue&type=template&id=46168b35&scoped=true"
import script from "./communications.vue?vue&type=script&lang=js"
export * from "./communications.vue?vue&type=script&lang=js"

import "./communications.vue?vue&type=style&index=0&id=46168b35&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46168b35"]])

export default __exports__